export default "/images/3ba86807f6edeca899fd06b4356d483a.avif";